<script lang="ts">
  import { onDestroy } from 'svelte';
  import { ConfigStore } from '../store/config';
  import { _, locale } from 'svelte-i18n';
  import { state_sessionStorage } from '../store/state';
  import { WindowsCustomEventTypes } from '../enums/windows-custom-event.enum';
  import { fly, fade } from 'svelte/transition';
  import { elasticInOut } from 'svelte/easing';
  import SvgIcon from './svg-icon.svelte';
  const closeNotification = () => {
    window.dispatchEvent(
      new CustomEvent(WindowsCustomEventTypes.showCsatPopup, {
        detail: {
          ...$state_sessionStorage?.csatRating,
          isNotification: false,
        },
      })
    );
  };

  onDestroy(() => {
    closeNotification();
    window.removeEventListener(
      WindowsCustomEventTypes.showCsatPopup,
      closeNotification
    );
  });
</script>

<button
  on:click={closeNotification}
  class="cs-rating-csat-notification__close"
  aria-label={$_('csat.close')}
><SvgIcon name="x" /></button>
<svg
  xmlns="http://www.w3.org/2000/svg"
  class="cs-rating-csat-notification__icon"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  stroke-width="1"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  />
</svg>
<h3
  class="cs-rating-csat-notification__title"
  aria-label={$ConfigStore.csatResponseTitle || $_('csat.notification.title')}
  role="status"
  aria-live="polite"
  aria-atomic="true"
  tabindex="0"
  title={$ConfigStore.csatResponseTitle || $_('csat.notification.title')}
>
  {$ConfigStore.csatResponseTitle || $_('csat.notification.title')}
</h3>
<div
  class="cs-rating-csat-notification__message"
  aria-label={$ConfigStore.csatResponseDescription ||
    $_('csat.notification.description')}
  role="status"
  aria-live="polite"
  aria-atomic="true"
  tabindex="0"
  title={$ConfigStore.csatResponseDescription ||
    $_('csat.notification.description')}
>
  {@html $ConfigStore.csatResponseDescription ||
    $_('csat.notification.description')}
</div>

<style lang="scss">
  @use '../../scss/components/_rating-csat-notification';
</style>
